import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';

function VoidAuth({apiUrl}) {
    const [voidAuth, setVoidAuth] = useState({
        operation: properties.OPERATIONS.voidAuthorise,
        timestamp:"",
        transactionid: transidgenerator(),
        vendorid: properties.VENDOR_ID,
        password: properties.PASSWORD,
        method: properties.HTTP_METHOD,
        description: properties.DESCRIPTION,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        token: properties.TOKEN,
        authCode: properties.AUTHCODE,
        security:""
    });

    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;
    
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setVoidAuth({ ...voidAuth, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setVoidAuth({ ...voidAuth, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setVoidAuth({ ...voidAuth, password: e.target.value });
    }

    function changeDesc(e) {
        setVoidAuth({ ...voidAuth, description: e.target.value });
    }

    function changeCurrency(e) {
        setVoidAuth({ ...voidAuth, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setVoidAuth({ ...voidAuth, token: e.target.value });
    }

    function changeAuthCode(e) {
        isNotNullCheck(e.target.value,"WPG_authCode");
        setVoidAuth({ ...voidAuth, authCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setVoidAuth({ ...voidAuth, region: e.target.value });
    }

    function submitVoidAuthForm(e) {
        e.preventDefault();
        isNotNullCheck(voidAuth.token,"WPG_token");
        isNotNullCheck(voidAuth.password,"vendorPwd");
        isNotNullCheck(voidAuth.vendorid,"WPG_vendorID");
        isNotNullCheck(voidAuth.transactionid,"WPG_transID");
        isNotNullCheck(voidAuth.authCode,"WPG_authCode");
        isNotNullCheck(voidAuth.region,"WPG_region");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(voidAuth.region === "NoR"){
                setVoidAuth({...voidAuth, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#voidauth_timestamp").val(time);
            var digest = md5(time + voidAuth.vendorid +
                voidAuth.transactionid + voidAuth.method +
                voidAuth.description +
                voidAuth.currency + voidAuth.region +
                voidAuth.token + voidAuth.authCode + voidAuth.password);
            $("#voidauth_security").val(digest);
            $("#voidauthForm").attr('action', apiUrl).submit();
        }
    }
    
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var voidAuthTemplate = (
        <div className="operation-form">
            <h2>Void Authorise</h2>
            <form className="form-horizontal" id="voidauthForm" onSubmit={submitVoidAuthForm} method='post'>
                <input type="hidden" name="WPG_timestamp" id="voidauth_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="voidauth_security" value="" />
                <input type="hidden" name="WPG_operation" value={voidAuth.operation} />
                <input type="hidden" name="WPG_method" value={voidAuth.method}/>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={voidAuth.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={voidAuth.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={voidAuth.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={voidAuth.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={voidAuth.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={voidAuth.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={voidAuth.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Auth Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_authCode" value={voidAuth.authCode} onChange={changeAuthCode} />
                        <div className="error-msg" name="WPG_authCode">Auth Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" id="voidAuthButton" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>

    );

    return voidAuthTemplate;
    
}

export default VoidAuth;